<template>
  <div class="partner-resumes-base-resumes-statuses">
    <div v-for="(status, index) in resume.statuses"
         :key="index"
         :class="{
           '_last-active': index === lastActive,
           '_current': index === current,
           '_active': typeof lastActive === 'number' &&  index <= lastActive,
           '_accent-green': status.color === 'green',
           '_accent-orange': status.color === 'orange',
           '_white': status.color === 'white',
         }"
         class="partner-resumes-base-resumes-statuses__item">
      <div v-if="index === lastActive || index === current"
           class="partner-resumes-base-resumes-statuses__item-text">
        {{ status.text }}
      </div>
      <div class="partner-resumes-base-resumes-statuses__item-number">
        {{ index }}
      </div>
      <div v-if="index === lastActive"
           class="partner-resumes-base-resumes-statuses__item-tick">
        <BaseSvg name="ico-tick"/>
      </div>

      <div class="partner-resumes-base-resumes-statuses__item-date  dropdown  _top">
        <div class="dropdown__content">
          <div v-if="status.text"
               :style="{marginBottom: status.date ? '0.4rem' : null}">
            {{ status.text }}
          </div>
          {{ status.date }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'APResumesBaseResumePageRowStatus',
    props: {
      resume: Object
    },
    data() {
      return {}
    },
    computed: {
      lastActive() {
        const a = this.resume.statuses.findIndex(s => s.active)
        return (a === -1) ? null : a
      },
      current() {
        if (typeof this.lastActive !== 'number') return 0

        const c = this.lastActive + 1

        if (c < this.resume.statuses.length) {
          return c
        }

        return this.resume.statuses.length - 1
      }
    }
  }
</script>

<style lang="less">

</style>
